<app-team-table
  class="green-scroll"
  [isAdmin]="isAdmin"
  [orgAccess]="orgAccess"
  [usersTable]="[{users: accessTeam, type: 'With access', opened: true},
                {users: noAccessTeam, type: 'Without access', opened: true}]"
  [organizationAccountId]="selectedOrgWithAccesses.organization.organizationId"
  [selectedOrganization]="selectedOrgWithAccesses.organization"
  (chosenUser)="chosenEmployee.emit($event)"
  (threeDotsClicked)="threeDotsClicked.emit($event)">
</app-team-table>
